module.exports = __webpack_public_path__ + "img/ruai (3).9968a4a0.png";